import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

const httpCompetitionLink = new HttpLink({
  uri: process.env.REACT_APP_COMPETITION_PATH,
})

export const apolloCompetitionClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: httpCompetitionLink,
})
